import { api } from "@/lib/api";

export interface AuditLogEntry {
  id: string;
  hospitalId: string | null;
  entityType: string;
  entityId: string;
  action: string;
  performedById: string | null;
  metadata: Record<string, unknown> | null;
  createdAt: string;
  performedBy?: { id: string; name: string; role: string } | null;
}

export const auditApi = {
  getAuditLog: (params?: { entityType?: string; entityId?: string; from?: string; to?: string; limit?: number }) =>
    api.get<{ data: AuditLogEntry[] }>("/api/audit", { params }),
};
